export default __webpack_public_path__ + "static/media/walmart.af94a6c2.png";